import { SET_PRODUCTS } from '../types/ProductTypes';
import { callGetImage } from '../../services/ImageService';

export const setProducts = (products) => {
  return { type: SET_PRODUCTS, products };
};

export const getImage = (sku) => {
  return async (dispatch, getState) => {
    const { products } = getState().productReducer;
    try {
      const res = await callGetImage(sku);
      if (res.status !== 200) {
        const productsWithImage = mergeImageWithProduct(products, sku, 'error');
        dispatch(setProducts(productsWithImage));
      } else {
        const productsWithImage = mergeImageWithProduct(
          products,
          sku,
          res.data.thumbnailImage,
        );
        dispatch(setProducts(productsWithImage));
      }
    } catch (err) {
      const productsWithImage = mergeImageWithProduct(products, sku, 'error');
      dispatch(setProducts(productsWithImage));
    }
  };
};

const mergeImageWithProduct = (products, sku, image) => {
  const productsWithImage = [];
  products.forEach((product) => {
    if (product.sku === sku.toString()) product.thumbnailImage = image;
    productsWithImage.push(product);
  });
  return productsWithImage;
};
